import { AxiosResponseHeaders } from 'axios';
import { OrderChargesResponseDTO } from '../entities';
import { OrderChargesResponseBody } from '../entities/OrderChargesResponseDTO';

const orderChargesResponseDTOToorderChargesResponseAdapter = (
  data: OrderChargesResponseDTO,
  headers?: AxiosResponseHeaders,
): OrderChargesResponseBody => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { orderChargesResponseDTOToorderChargesResponseAdapter };
